// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-ProfilePage-UserSection-UserSection-module__EditProfileButton";
var _2 = "webpack-pages-ProfilePage-UserSection-UserSection-module__UserDetailsContainer";
export { _1 as "EditProfileButton", _2 as "UserDetailsContainer" }
